import axios from 'axios';
import myaxios from './axios';
import * as Urls from '../constants/backendUrls';

// Auth Side Effects
export const signup = async (formData) => {
    try {
        const result = await axios.post(Urls.signup, formData);
        return result;
    } catch (error) {
        return error.response;
    }
}

export const login = async (formData) => {
    try {
        const result = await axios.post(Urls.login, formData);
        return result;
    } catch (error) {
        return error.response;
    }
}

export const changePassword = async (formData) => {
    try {
        const result = await myaxios().patch(Urls.changePassword, formData);
        return result;
    } catch (error) {
        return error.response;
    }
}

// Message Module Side Effects
export const fetchContacts = async () => {
    try {
        const result = await myaxios().get(Urls.getContacts);
        return result;
    } catch (error) {
        return error.response;
    }
}

export const fetchMessages = async (contactUserId) => {
    try {
        const result = await myaxios().get(`${Urls.getMessages}/${contactUserId}`);
        return result;
    } catch (error) {
        return error.response;
    }
}

export const sendMessage = async (message) => {
    try {
        const result = await myaxios().post(Urls.postMessage, { message });
        return result;
    } catch (error) {
        return error.response;
    }
}

export const getEmojiRecommendations = async (message) => {
    // 'https://emoji-recommendation.herokuapp.com/' + message
    try {
        const result = await myaxios().post(Urls.postEmojiRecommendation, { message });
        return result;
    } catch (error) {
        return error.response;
    }
}

// User Acount Side Effects
export const fetchInterests = async () => {
    try {
        const result = await myaxios().get(Urls.getInterests);
        return result;
    } catch (error) {
        return error.response;
    }
}

export const SaveInterests = async (interests) => {
    try {
        const result = await myaxios().put(Urls.putInterests, { interests });
        return result;
    } catch (error) {
        return error.response;
    }
}

export const fetchProfilePicture = async () => {
    try {
        const result = await myaxios().get(Urls.getProfilePicture);
        return result;
    } catch (error) {
        return error.response;
    }
}

export const saveProfilePicture = async (formData) => {
    try {
        const result = await myaxios().put(Urls.putProfilePicture, formData);
        return result;
    } catch (error) {
        return error.response;
    }
}